@import 'apps/webcomponents/src/assets/style-helpers.scss';
@import 'apps/webcomponents/src/assets/flexbox-helpers.scss';
@import 'apps/webcomponents/src/assets/color-helpers.scss';
@import 'apps/webcomponents/src/assets/common.scss';
@import './windowShared.scss';

.overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s ease;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;

  &:before {
    content: '';
    display: block;
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    background-color: var(--chart-304-icon-buttons);
  }
}

.focusable:focus-visible {
  outline: none;
}

:host([isOpen]) {
  .overlay {
    opacity: 1;
    visibility: visible;
  }
}

.dialog,
.window {
  background-color: var(--white-layout-302-level-1-elevation);
  position: relative;
  display: flex;
  border-radius: 4px;

  &--header {
    padding-bottom: calc(4 * var(--spacer));
  }

  &--content {
    display: flex;
    width: 100%;
    min-height: 100%;
    flex-direction: column;
    justify-content: space-between;
  }

  &--title {
    line-height: 33px;
  }

  &--message {
    font-size: var(--dialog-font-size);
    display: flex;
    align-items: center;
    overflow-y: auto;
    color: var(--body-text-arrows-400);

    > * {
      flex: 1;
    }

    p {
      margin: 0;
      --font-family: var(--font-family-secondary);
    }
  }

  &--footer {
    display: flex;
    padding-top: calc(4 * var(--spacer));
    div {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }

  .dialog-icon {
    font-size: 54px;
    margin-right: calc(var(--spacer) * 3);
  }
}

.dialog {
  width: 70%;
  max-width: 640px;
  padding: calc(5 * var(--spacer));

  .dialog-close {
    position: absolute;
    top: var(--spacer);
    right: var(--spacer);
    height: auto;
  }

  &--message {
    max-height: 50vh;
  }
}

.window {
  width: 100%;
  height: 100%;
  background: var(--white-layout-302-level-1-elevation);

  &--header {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    padding: calc(1.44 * var(--spacer)) calc(2 * var(--spacer)) calc(1.44 * var(--spacer)) calc(5 * var(--spacer));
    background: var(--white-layout-302-level-1-elevation);
  }

  &--message {
    display: block;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding: 0;
    margin: 0;
  }

  &--footer {
    @include windowFooter;
  }

  .dialog-close {
    margin-left: auto;
  }
}
